export const TID = {
  announcementBar: "announcement-bar",
  announcementCta: "announcement-cta",
  header: "site-header",
  headerLogo: "header-logo",
  headerNavLink: (name) => `nav-link-${name}`,
  headerCta: "header-cta",
  mobileMenuToggle: "mobile-menu-toggle",
  mobileMenu: "mobile-menu",

  heroSection: "hero-section",
  heroH1: "hero-h1",
  heroCtaPrimary: "hero-cta-primary",
  heroCtaSecondary: "hero-cta-secondary",

  trustStrip: "trust-strip",
  problemStatement: "problem-statement",
  coreSolutions: "core-solutions",
  solutionCard: (i) => `solution-card-${i}`,
  whoWeHelp: "who-we-help",
  segmentCard: (i) => `segment-card-${i}`,
  outcomesMarquee: "outcomes-marquee",
  featuredWork: "featured-work",
  caseStudyCard: (i) => `case-study-card-${i}`,
  whyTechovarya: "why-techovarya",
  principleCard: (i) => `principle-card-${i}`,
  engagementModels: "engagement-models",
  engagementCard: (i) => `engagement-card-${i}`,
  technologyEcosystem: "technology-ecosystem",

  contactSection: "contact-section",
  contactForm: "contact-form",
  contactInputName: "contact-input-name",
  contactInputEmail: "contact-input-email",
  contactInputCompany: "contact-input-company",
  contactInputWebsite: "contact-input-website",
  contactSelectRole: "contact-select-role",
  contactSelectNeed: "contact-select-need",
  contactSelectStage: "contact-select-stage",
  contactSelectBudget: "contact-select-budget",
  contactTextareaChallenge: "contact-textarea-challenge",
  contactSubmit: "contact-submit",

  footer: "site-footer",
  footerCta: "footer-cta",
};
